import React from 'react';


class Intent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {isToggleOn: true};
  }

  handleClick = (e) => {
    this.props.handleSelection(this.props.tag);
  }

  handleMouseOver = (e) => {
    this.props.handleHover(this.props.intent);
  }
  handleMouseOut = (e) => {
    this.props.handleHover(null);
  }

  getClass(){
    return this.props.isSelected ? 'intent selected' : 'intent';
  }

  getImage(){
    return  <img src={this.props.image}/>
  }

  render() {
    return (
      <div className={this.getClass()} onClick={this.handleClick} onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}>
        {this.props.name}
        {this.props.image?this.getImage():''}
      </div>
    );
  }
}

export default Intent;
